import {DATE_FORMAT, SurgicalInformedConsentForm} from "../../common";
import {Button, Col, DatePicker, Divider, Input, InputNumber, Row} from "antd";
import React, { useRef } from "react";
import { formatDateStrInput } from "../common";
import "./index.css";
import handleAxios, {SurgicalInformedConsentFileDownLoad} from "../../../../Http/request";
import {SUBMIT_TYPE} from "../../../../Http/common";

interface P {
  defaultValue: SurgicalInformedConsentForm;
  newValue?: SurgicalInformedConsentForm;
  fatherChange(newValue: SurgicalInformedConsentForm): void;
  saveDraft(newDraft: SurgicalInformedConsentForm | undefined, saveType: SUBMIT_TYPE): void
}

/**
 * 手术知情同意书
 */
export default function ({ defaultValue, newValue, fatherChange, saveDraft }: P) {
  // 当前模块的值
  const moduleValue = useRef<SurgicalInformedConsentForm | undefined>(defaultValue);

  /**
   * 更新模块中的某个值
   */
  const partChange = (newValue: Partial<SurgicalInformedConsentForm>): void => {
    let newModuleValue: SurgicalInformedConsentForm;
    if (moduleValue.current === undefined) {
      newModuleValue = { ...defaultValue };
      moduleValue.current = newModuleValue;
    }
    newModuleValue = {
      ...moduleValue.current,
      ...newValue,
    };
    moduleValue.current = newModuleValue;
    fatherChange(newModuleValue);
  };

  return (
    <>
      <Row
        justify="start"
        align="middle"
        className="custom-line-row"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      >
        <Col span={2}>姓名</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.name}
            onChange={(e) => {
              partChange({ name: e.target.value });
            }}
          />
        </Col>
        <Col span={2}>性别</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.gender}
            onChange={(e) => {
              partChange({ gender: e.target.value });
            }}
          />
        </Col>

        <Col span={2}>年龄</Col>
        <Col span={2}>
            <InputNumber
                changeOnWheel
                style={{
                    width: "100%"
                }}
                defaultValue={defaultValue.age}
                onChange={(e:number | null) => {
                    partChange({age: e === null ? undefined : e})
                }}
                addonAfter={"岁"}
            />
        </Col>
        <Col span={2}>身份证号</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.IDNumber}
            onChange={(e) => {
              partChange({ IDNumber: e.target.value });
            }}
          />
        </Col>
      </Row>

      <Row justify="start" align="middle" className="custom-line-row">
          <Col span={2}>临床诊断</Col>
          <Col span={4}>
              <Input
                  defaultValue={defaultValue.clinicalDiagnosis}
                  onChange={(e) => {
                      partChange({ clinicalDiagnosis: e.target.value });
                  }}
              />
          </Col>
        <Col span={2}>手术方式1</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.surgeryWay1}
            onChange={(e) => {
              partChange({ surgeryWay1: e.target.value });
            }}
          />
        </Col>
        <Col span={2}>手术方式2</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.surgeryWay2}
            onChange={(e) => {
              partChange({ surgeryWay2: e.target.value });
            }}
          />
        </Col>
        <Col span={2}>手术方式3</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.surgeryWay3}
            onChange={(e) => {
              partChange({ surgeryWay3: e.target.value });
            }}
          />
        </Col>
      </Row>

      <Row justify="start" align="middle" className="custom-line-row">
        <Col span={2}>麻醉方式</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.anesthesiaType}
            onChange={(e) => {
              partChange({ anesthesiaType: e.target.value });
            }}
          />
        </Col>
        <Col span={2}>手术医生</Col>
        <Col span={4}>
          <Input
            defaultValue={defaultValue.operator}
            onChange={(e) => {
              partChange({ operator: e.target.value });
            }}
          />
        </Col>
        <Col span={2}>签名日期</Col>
        <Col span={4}>
          <DatePicker
            style={{ width: "100%" }}
            showTime={{ format: 'HH:mm' }}
            defaultValue={formatDateStrInput(defaultValue.recordTimeStr, DATE_FORMAT)}
            onChange={(value, dateStr: string | string[]) => {
              if (typeof dateStr === 'string') {
                partChange({ recordTimeStr: dateStr });
              } else {
                partChange({ recordTimeStr: dateStr[0] });
              }
            }}
          />
        </Col>
      </Row>
        <Row
            justify="start"
            align="middle"
            style={{
                marginTop: "10px",
                marginBottom: "10px"
            }}
        >
            <Divider>下载&保存</Divider>
            <Col span={4}>
                <Button
                    type={'link'}
                    onClick={() => {
                        SurgicalInformedConsentFileDownLoad(moduleValue.current!);
                        saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_MODIFY);
                    }}
                >
                    下载手术知情同意书
                </Button>
            </Col>
            <Col span={4}>
                <Button
                    type={"primary"}
                    onClick={() => saveDraft(moduleValue.current, SUBMIT_TYPE.TYPE_MODIFY)}>
                    保存手术知情同意书草稿
                </Button>
            </Col>
        </Row>
    </>
  );
}